/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchOrganizationCombosRequestInnerAllOfSchedulesInner } from './PatchOrganizationCombosRequestInnerAllOfSchedulesInner';
import {
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSON,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSONTyped,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSON,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSONTyped,
} from './PatchOrganizationCombosRequestInnerAllOfSchedulesInner';
import type { PatchOrganizationCombosRequestInnerAllOfCategoriesInner } from './PatchOrganizationCombosRequestInnerAllOfCategoriesInner';
import {
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSON,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSONTyped,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSON,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSONTyped,
} from './PatchOrganizationCombosRequestInnerAllOfCategoriesInner';

/**
 * 
 * @export
 * @interface PatchOrganizationComboRequest
 */
export interface PatchOrganizationComboRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationComboRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationComboRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchOrganizationComboRequest
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationComboRequest
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationComboRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationComboRequest
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchOrganizationComboRequest
     */
    hasSchedule?: boolean;
    /**
     * 
     * @type {Array<PatchOrganizationCombosRequestInnerAllOfCategoriesInner>}
     * @memberof PatchOrganizationComboRequest
     */
    categories?: Array<PatchOrganizationCombosRequestInnerAllOfCategoriesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchOrganizationComboRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {Array<PatchOrganizationCombosRequestInnerAllOfSchedulesInner>}
     * @memberof PatchOrganizationComboRequest
     */
    schedules?: Array<PatchOrganizationCombosRequestInnerAllOfSchedulesInner>;
}

/**
 * Check if a given object implements the PatchOrganizationComboRequest interface.
 */
export function instanceOfPatchOrganizationComboRequest(value: object): value is PatchOrganizationComboRequest {
    return true;
}

export function PatchOrganizationComboRequestFromJSON(json: any): PatchOrganizationComboRequest {
    return PatchOrganizationComboRequestFromJSONTyped(json, false);
}

export function PatchOrganizationComboRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchOrganizationComboRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'price': json['price'] == null ? undefined : json['price'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'hasSchedule': json['hasSchedule'] == null ? undefined : json['hasSchedule'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSON)),
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'schedules': json['schedules'] == null ? undefined : ((json['schedules'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSON)),
    };
}

export function PatchOrganizationComboRequestToJSON(json: any): PatchOrganizationComboRequest {
    return PatchOrganizationComboRequestToJSONTyped(json, false);
}

export function PatchOrganizationComboRequestToJSONTyped(value?: PatchOrganizationComboRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'price': value['price'],
        'color': value['color'],
        'description': value['description'],
        'imageId': value['imageId'],
        'hasSchedule': value['hasSchedule'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSON)),
        'enabled': value['enabled'],
        'schedules': value['schedules'] == null ? undefined : ((value['schedules'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSON)),
    };
}

